/**
 * 86-23: upload refusals the server marks with a tRPC cause code, shown in
 * the operator's own language instead of the server's English message.
 * The codes are registered in the backend's FORWARDABLE_CAUSE_CODES.
 */
const UPLOAD_REFUSAL_KEYS: Readonly<Record<string, string>> = {
  PRODUCT_SYNC_UPLOAD_NEW_PRODUCT: 'upload.refusal.newProduct',
  PRODUCT_SYNC_UPLOAD_TYPE_NO_CODE: 'upload.refusal.typeNoCode',
};

/** The i18n key for a coded upload refusal, or null for any other error. */
export function uploadRefusalKey(err: unknown): string | null {
  const code = (err as { data?: { cause?: { code?: unknown } } } | null | undefined)?.data?.cause?.code;
  return typeof code === 'string' ? (UPLOAD_REFUSAL_KEYS[code] ?? null) : null;
}
